import { HomeFeaturedArticleType } from '@nextTypes/guides';

import { ImageCard, ImageCardLarge } from '@common/ImageCard';

import { RecipesAndGuidesContainer } from './RecipesAndGuidesContainer';
import { createBlogImageCards } from './RecipesAndGuidesUtils';

type Props = {
  articles: HomeFeaturedArticleType[];
};

export const BlogSection = ({ articles }: Props): JSX.Element | null => {
  // We want the first article to appear as an ImageCard, while the
  // next 3 articles follow rather different styling
  const remainingCards = createBlogImageCards(articles.slice(1));

  return (
    <RecipesAndGuidesContainer
      backgroundColour="bg-blue"
      buttonColour="White"
      categoryTitle="Blog"
      categoryTitleColour="text-mono-white"
      cta="More from our Blog"
      ctaColour="text-blue-100"
      href="/blog"
    >
      <div className="flex flex-col items-center text-blue lg:flex-row lg:items-start">
        <div className="mb-6 lg:hidden">
          <ImageCard
            image={articles[0].backgroundImage}
            title={articles[0].title}
            supertitle={articles[0]?.authorName}
            altText={articles[0]?.description || ''}
            href={articles[0].href}
          />
        </div>
        <div className="hidden lg:mr-6 lg:block">
          <ImageCardLarge
            image={articles[0].backgroundImage}
            title={articles[0].title}
            supertitle={articles[0]?.authorName}
            altText={articles[0]?.description || ''}
            href={articles[0].href}
          />
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-1">{remainingCards}</div>
      </div>
    </RecipesAndGuidesContainer>
  );
};
